import type { IInvoice, IInvoiceLine, ISalesperson } from '@posx/core';

// Assign salespersons to invoice/line: primary storage is salespersons field, sales_user_uid + meta.sales_user_name kept in sync for backward compatibility
export const assignSalespersons = (entity: IInvoice | IInvoiceLine, salespersons: ISalesperson[]) => {
  const first = salespersons[0];
  entity.sales_user_uid = first?.uid ?? '';
  entity.meta = { ...entity.meta, sales_user_name: first?.name ?? null };
  entity.salespersons = salespersons;
};

// Resolve salespersons for dialog init/display: prefer salespersons field, then legacy meta.salespersons (pre-existing records), then sales_user_uid
export const resolveSalespersons = (entity?: Partial<IInvoice | IInvoiceLine>): ISalesperson[] =>
  entity?.salespersons?.length ? entity.salespersons
  : entity?.meta?.salespersons?.length ? entity.meta.salespersons
  : entity?.sales_user_uid ? [{ uid: entity.sales_user_uid, name: entity.meta?.sales_user_name ?? '', commission_amount: 0 }]
  : [];
